import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-number-decimal',
  templateUrl: './r-con-number-decimal.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConNumberDecimalComponent),
      multi: true
    }
  ]
})
export class RConNumberDecimalComponent extends RenderComponentBase {
  static KEY = 'r-d-con-number-decimal';

  // @HostBinding('style.float') float = 'left';
  ruleType = ValidationRuleType;

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
    if (!config.effective) {
      config.effective = [];
    }
  }
}
